/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// Material UI
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

// Checkout
import { getBrand } from '../../../../../../../../../state/ducks/Checkout/ducks/Common/Common-Selectors';

const styles = (theme) => ({
    appBarRaised: {
        position: 'static',
        backgroundColor: theme.palette.white,
        color: theme.palette.black,
        boxShadow: 'none',
    },
    toolbar: {
        minHeight: '48px',
        paddingRight: '0',
    },
    typography: {
        flex: '1',
        fontSize: '1em',
        fontWeight: '700',
        // textTransform: 'uppercase',
    },
    [theme.breakpoints?.up('sm')]: {
        appBarRaised: {
            backgroundColor: (theme.palette.primary?.main || '#2f2f2f'),
            color: (theme.palette.primary?.contrastText || '#ffffff'),
        },
        toolbar: {
            minHeight: '38px',
            height: '38px',
            paddingRight: '0',
        },
    },
});

const DeliveryCalendarHeader = ({ classes, closeDeliveryCalModel, deliveryTextData }) => (
    <AppBar className={classes.appBarRaised}>
        <Toolbar className={classes.toolbar}>
            <Typography
                variant="h6"
                color="inherit"
                className={classes.typography}
            >
                {(deliveryTextData.deliveryHeaderTitle || 'Select Delivery Date')}
            </Typography>
            <IconButton
                color="inherit"
                onClick={() => {
                    closeDeliveryCalModel();
                }}
                aria-label="Close"
                data-test="checkout-delivery-calendar-close-button"     // do NOT change or remove data-test attribute
            >
                <CloseIcon />
            </IconButton>
        </Toolbar>
    </AppBar>
);

const mapStateToProps = (state) => ({
    brand: getBrand(state),
});

DeliveryCalendarHeader.propTypes = {
    classes: PropTypes.object.isRequired,
    closeDeliveryCalModel: PropTypes.func.isRequired,
    deliveryTextData: PropTypes.shape({
        deliveryHeaderTitle: PropTypes.string.isRequired,
        deliveryHeaderCaption: PropTypes.string.isRequired,
    }),
};
DeliveryCalendarHeader.defaultProps = {
    deliveryTextData: {},
};

const styleDeliveryCalendarHeader = withStyles(styles)(DeliveryCalendarHeader);
export default connect(mapStateToProps)(withRouter(styleDeliveryCalendarHeader));
